import { useEffect } from "react";
import { useSelector } from "react-redux";
import Chart from "react-apexcharts";
import { useDashboardStore } from "../../../hooks";
import { LoadingData, ErrorMessage } from "../../ui";
import { optionsAverageSchedulingCompletion } from "../../data";

export const AverageSchedulingCompletionChart = () => {
  // Datos del hook ----------------------------------------//
  const { isLoading, data, errorMessage } = useSelector(
    (state) => state.dashboard.averageSchedulingCompletion
  );

  const { getDataAverageSchedulingCompletion } = useDashboardStore();

  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (!data) {
      getDataAverageSchedulingCompletion();
    }
  }, [data, getDataAverageSchedulingCompletion]);

  return (
    <div className="card shadow border-0 p-4 h-100">
      {isLoading && <LoadingData />}
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
      {data && (
        <>
          <h6 className="align-items-center mb-0">
            Promedio de procedimientos agendados / ordenados con go safe
          </h6>
          <Chart
            options={optionsAverageSchedulingCompletion}
            series={data.series}
            type="bar"
            width="100%"
            height={350}
          />
        </>
      )}
    </div>
  );
};
